<template>
  <div class="home_product">
    <div class="gsjj">
      <p class="p1">公司荣誉</p>
      <div class="fg"></div>
    </div>
    <div class="gsjj_title">
      <ul>
        <li>
          <img src="../../assets/images/product/homeProduct.png" alt />
          <p>高新技术企业证书</p>
        </li>
        <li>
          <img src="../../assets/images/product/homeProduct1.png" alt />
          <p style="width: 270px;">杭州市“雏鹰计划”企业证书</p>
        </li>
        <li>
          <img src="../../assets/images/product/homeProduct2.png" alt />
          <p>万泰认证证书</p>
        </li>
        <li>
          <img src="../../assets/images/product/homeProduct3.png" alt/>
          <p style="width: 270px;">区块链服务网络（BSN）合格开发者证书</p>
        </li>
      </ul>
    </div>

    <!-- <div class="init">
      <div class="title">/ 客户案例 /</div>
      <div class="title2">一站式全方案，提供金融技术服务</div>
      <div class="class">
        <div class="class_init">
          <a v-for="(it, idx) in industryList" :key="idx" @click="industryClick(it, idx)"
            :class="industryIndex == idx ? 'select' : ''" href="javascript:;">{{ it }}</a>
        </div>
      </div>
      <div id="ProductContainer" class="lst swiper-container">
        <div class="wrap swiper-wrapper">
          <div class="item swiper-slide" v-for="(item, index) in productList" :key="index">
            <div class="itemct">
              <div class="img">
                <img :src="baseConfig.baseUrl + item.picture" alt="" />
              </div>
              <div class="text">
                {{ item.caseName }}
              </div>
              <div class="hovertext">
                {{ item.caseName }}
              </div>

            </div>
          </div>
        </div>
      </div>
      <div id="ProductButtonPrev" class="prev hide">
        <icon name="chevron-left"></icon>
      </div>
      <div id="ProductButtonNext" class="next hide">
        <icon name="chevron-right"></icon>
      </div>
      <div class="more">
        <a href="/product">
          <span>查看全部</span>
          <icon name="caret-right" fill="#073875"></icon>
        </a>
      </div>
    </div>-->
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import "swiper/js/swiper.min.js";
import { getProductList } from "@/apis/product";
export default {
  data() {
    return {
      productList: [],
      industryList: ["金融行业", "政府数改", "企业服务"],
      industryIndex: -1,
      industry: ""
    };
  },

  created() {
    var me = this;
    me.loadProductList();
  },
  beforeDestroy: function() {
    var me = this;
    me.resizer.un(me._ResizeId);
  },
  methods: {
    loadProductList(params) {
      let me = this;
      params = params || {};
      params.pageNum = params.pageNum || 1;
      params.pageSize = params.pageSize || 8;
      params.status = params.status || 0;
      params.industry = params.industry || me.industry;
      me.mySwiper && me.mySwiper.destroy();
      me._getProductList(params, function() {
        me.$nextTick(() => {
          me.initSwiper();
        });
        me.$nextTick(() => {
          me.resizer.trigger();
        });
      });
    },
    _getProductList(params, onInit) {
      getProductList(params).then(res => {
        this.productList = res.rows;
        onInit && onInit();
      });
    },
    initSwiper() {
      var me = this;
      me.mySwiper = new Swiper("#ProductContainer", {
        loop: true,
        speed: 1500,
        parallax: true,
        slidesPerView: 3,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: "#ProductButtonPrev",
          prevEl: "#ProductButtonNext"
        }
      });
      //鼠标移出隐藏按钮，移入显示按钮
      let emt = document.getElementById("ProductContainer").parentNode
        .parentNode;
      emt.onmouseover = () => {
        var nv = me.mySwiper.navigation;
        nv.$nextEl.removeClass("hide");
        nv.$prevEl.removeClass("hide");
      };
      var mouserout = (emt.onmouseout = () => {
        var nv = me.mySwiper.navigation;
        nv.$nextEl.addClass("hide");
        nv.$prevEl.addClass("hide");
      });
      mouserout();
      me._ResizeId = me.resizer.un(me._ResizeId).onWidth(768, function(w) {
        if (w > 768) {
          me.mySwiper.params.slidesPerView = 3;
        } else {
          me.mySwiper.params.slidesPerView = 1;
        }
        me.mySwiper.update();
      });
      me.resizer.trigger();
    },
    industryClick(text, idx) {
      var me = this;
      me.industryIndex = idx;
      me.industry = text;
      me.loadProductList();
    }
  }
};
</script>

<style scoped>
.hide {
  opacity: 0;
}

.next,
.prev {
  transition: opacity 0.5s;
}

.clear {
  clear: both;
}

.home_product {
  width: 100%;
  height: 650px;
  background-color: #fff;
  /* background-color: #ef0b0b; */
  position: relative;
}

.gsjj {
  width: 208px;
  height: 99px;
  /* background-color: #073875; */
  margin: 0 auto;
  padding-top: 18px;
  margin-bottom: 80px;
  /* margin-top: 100px; */
}
.fg {
  width: 165px;
  height: 5px;
  background: #0a41ff;
  border-radius: 0px 0px 0px 0px;
  margin: 47px 21px 0px 22px;
}
.p1 {
  width: 208px;
  height: 52px;
  font-size: 52px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  line-height: 93px;
  /* // -webkit-background-clip: text; */
  /* // -webkit-text-fill-color: transparent; */
}
.gsjj_title {
  margin: 0 auto;
  width: 1600px;
  height: 368px;
  /* background-color: #0a41ff; */
}
.gsjj_title > ul {
  display: flex;
  justify-content: space-between;
  width: 1600px;
  height: 368px;
  /* background-color: #07b2e6; */
}
.gsjj_title > ul > li {
  /* padding: 10px 0px 0px 9px; */
  width: 359px;
  height: 358px;
  background: #ffffff;
  /* box-shadow: 0px 3px 6px 1px rgba(232, 232, 232, 0.6); */
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #d8d8d8;
  line-height: normal;
}
.gsjj_title>ul>li:hover{
  box-shadow: 5px 5px 10px rgba(128, 128, 128, 0.5);
}
.gsjj_title > ul > li > p {
  /* display: inline-block; */
  padding-top: 30px;
  width: 192px;
  height: 24px;
  font-size: 24px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  /* line-height: 68px; */
  /* padding-top: 30px; */
  margin: 0 auto;
  /* -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; */
}
.gsjj_title ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.gsjj_title ul li img {
  padding-top: 10px;
  margin: 0 auto;
}





.init {
  width: 80%;
  margin: 0 auto;
  padding: 0 0 0.8rem;
  max-width: 1196px;
}

.title {
  color: #073875;
  line-height: 0.48rem;
  font-size: 0.48rem;
  text-align: center;
}

.title2 {
  margin-top: 0.15rem;
  color: #333;
  line-height: 0.18rem;
  font-size: 0.18rem;
  text-align: center;
}

.class {
  text-align: center;
  display: block;
}

.class_init {
  margin: 0.5rem auto;
  line-height: 0.54rem;
  border: 1px solid #ebebeb;
  border-radius: 2.7rem;
  display: inline-block;
}

.class a {
  height: 0.54rem;
  padding: 0 0.3rem;
  font-size: 0.16rem;
  font-weight: 600;
  text-align: center;
  color: #073875;
  float: left;
  flex: 1;
}

.class a:hover {
  margin: -1px;
  border: 1px solid #ccc;
  border-radius: 2.7rem;
}

.class a.select {
  margin: -1px;
  border: 1px solid #073875;
  border-radius: 2.7rem;
}

.more {
  line-height: 0px;
  text-align: center;
}

.more a {
  margin: 0.5rem auto 0;
  padding: 0 0.4rem;
  line-height: 0.4rem;
  font-size: 0.2rem;
  color: #073875;
  border: 1px solid #073875;
  background-color: #fff;
  text-align: center;
  border-radius: 0.25rem;
  display: inline-block;
}

.more a:hover {
  border: 1px solid #073875;
  background-color: #eee;
}

.more svg,
.more span {
  vertical-align: middle;
}

.more svg {
  margin-left: 5px;
}

.swiper-container .hide {
  opacity: 0;
}

.swiper-button-next,
.swiper-button-prev {
  transition: opacity 0.5s;
}

.lst {
  padding: 10px 0;
}

.item {
  width: 3rem;
  height: 3.7rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.itemct {
  width: 90%;
  border: 1px solid #fff;
  overflow: hidden;
  position: relative;
  border-radius: 5px;
  box-shadow: 3px 3px 10px -4px rgb(0 0 0 / 20%);
}

.item .img {
  width: 100%;
  height: 3.15rem;
  overflow: hidden;
}

.item img {
  width: 100%;
}

.text {
  width: 100%;
  height: 0.55rem;
  font-size: 0.18rem;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 0.55rem;
  color: #333;
  text-align: center;
  background-color: #fff;
  display: block;
}

.hovertext {
  display: none;
}

.item:hover .hovertext {
  width: 100%;
  height: 100%;
  line-height: 3.7rem;
  font-size: 0.18rem;
  font-family: PingFang SC;
  font-weight: 500;
  text-align: center;
  color: #fff;
  background-color: rgba(13, 103, 220, 0.8);
  top: 0;
  left: 0;
  position: absolute;
  display: block;
}

.prev,
.next {
  left: 4%;
  position: absolute;
  cursor: pointer;
  bottom: 3.5rem;
  fill: #bbb;
}

.prev:hover,
.prev:active,
.next:hover,
.next:active {
  fill: #333;
}

.next {
  left: auto;
  right: 4%;
}

@media screen and (max-width: 768px) {
  .title {
    line-height: 0.8rem;
    font-size: 0.8rem;
  }

  .title2 {
    margin-top: 0.3rem;
    line-height: 0.4rem;
    font-size: 0.4rem;
  }

  .class_init {
    margin: 0.5rem auto;
    line-height: 0.75rem;
    border-radius: 0.4rem;
  }

  .class a {
    height: 0.75rem;
    padding: 0 0.7rem;
    font-size: 0.35rem;
    font-weight: 600;
  }

  .item {
    height: 6.05rem;
  }

  .item .img {
    height: 5.15rem;
  }

  .text {
    height: 0.9rem;
    line-height: 0.9rem;
    font-size: 0.35rem;
  }

  .item:hover .hovertext {
    line-height: 6.05rem;
    font-size: 0.35rem;
  }

  .more a {
    padding: 0 0.6rem;
    line-height: 0.8rem;
    font-size: 0.35rem;
    border-radius: 0.5rem;
  }

  .prev,
  .next {
    bottom: 5rem;
  }
}

@media screen and (max-width: 560px) {
  .class a {
    width: 100%;
    padding: 0;
  }
}

@media screen and (max-width: 500px) {
  .title {
    line-height: 0.6rem;
    font-size: 0.6rem;
  }
}
</style>